import type { TenantConfig } from '@/types/TenantConfig'

export const fetishandfantasyhalloweenball: TenantConfig = {
  themeMode: 'dark',
  themeOptions: {
    dialog: {
      headerBackground: '#222222',
      backgroundColor: '#333333',
      headerIconColor: '#ffffff',
      headerBorder: '0',
    },
    mobileFooter: {
      cartButtonIconColor: 'white',
      cartButtonBackgroundColor: 'transparent',
      cartButtonHoverBackgroundColor: 'transparent',
      cartButtonBorder: '2px solid #666666',
      backgroundColor: '#222222',
      textColor: 'white',
      priceTextColor: 'white',
    },
    backButton: {
      backgroundColor: '#cb001f',
    },
  },
  logo: 'assets/fetishandfantasyhalloweenball/static/logo2.png',
  componentOptions: {
    stripeCreditCard: {
      fontFaceStylesheet: 'https://fonts.googleapis.com/css2?family=Metal+Mania&family=Raleway&display=swap',
    },
  },
}
